<template>
    <div class="bazis-finance-page">
        <breadcrumbs></breadcrumbs>
        <div class="container">
            <div class="section-title">
                <h1>{{pageSetup.page_title}}</h1>
            </div>
            <!-- <BanerTopVertical :options="[{page: 'bazis-finance'}]" class="bazis-finance-vertical-baner-top" v-if="banerSystem != undefined && banerSystem.baner_system_active == 'true'"></BanerTopVertical> -->
            <div class="section-title-desc">
                <h2>{{pageSetup.page_title_desc}}</h2>
            </div>

            <div class="default-desc-main-red hypothec-desc-main">
                <div class="desc-column-container">
                    <div class="column-left">
                        <div class="desc-red">
                            <p>{{pageSetup.desc_red}}</p>
                        </div>
                        <div class="col-img-mobile">
                            <img :src="pageSetup.img" alt="">
                        </div>
                        <div class="desc-base">
                            <p>{{pageSetup.desc_under_red}}</p>
                        </div>
                        <!-- <router-link :to="{name: 'hypothec-calculator'}" class="calculator-link">Ипотечный калькулятор</router-link> -->
                    </div>
                    <div class="column-right">
                        <div class="col-img">
                            <img :src="pageSetup.img" alt="">
                        </div>
                    </div>
                </div>
            </div>

            <pageDescUniq :options="[{title: pageSetup.desc_red_bold, data_page: 'Bazis Finance', data_page_key: 'bazis-finance'}]"></pageDescUniq>
            
            <div class="bazis-finance-checkers-title">
                <h2>{{pageSetup.buy_title}}</h2>
            </div>
            <div class="bazis-finance-checkers">
                <div class="item" v-for="item in pageSetup.cards">
                    <div class="item-icon">
                        <svg-icon icon-class="check" className="icon-check"/>
                    </div>
                    <p>{{item.title}}</p>
                    <div class="item-desc">
                        <p v-for="list in item.list">{{list.desc}}</p>
                    </div>
                </div>
            </div>
            <div class="bazis-finance-biggest-info">
                <div class="title">
                    <h2>{{pageSetup.cards_bottom_info.title}}</h2>
                </div>
                <div class="title-second">
                    <h3>{{pageSetup.cards_bottom_info.title_view}}</h3>
                </div>
                <div class="col-items">
                    <div class="col">
                        <div class="item" v-for="item in pageSetup.cards_bottom_info.list_info.slice(0,1)">
                            <h4>{{item.name}}</h4>
                            <div class="list" v-for="list in item.info">
                                <p>{{list.stroke}}</p>
                            </div>
                        </div>
                        <div class="desc-red">
                            <p>{{pageSetup.cards_bottom_info.red_desc_col}}</p>
                        </div>
                    </div>
                    <div class="col">
                        <div class="item" v-for="item in pageSetup.cards_bottom_info.list_info.slice(1,4)">
                            <h4>{{item.name}}</h4>
                            <div class="list" v-for="list in item.info">
                                <p>{{list.stroke}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="item" v-for="item in pageSetup.cards_bottom_info.list_info.slice(4)">
                            <h4>{{item.name}}</h4>
                            <div class="list" v-for="list in item.info">
                                <p>{{list.stroke}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bazis-finance-bank-cards">
            <div class="container">
                <div class="bank-cards-title">
                    <h2>{{pageSetup.cards_bank_title}}</h2>
                </div>
                <div class="cards-items">
                    <div class="item" v-for="item in pageSetup.cards_bank">
                        <div class="logo">
                            <img :src="item.logo" alt="">
                        </div>
                        <div class="title">
                            <h3>{{item.name}}</h3>
                        </div>
                        <div class="desc">
                            <ul>
                                <li v-for="desc in item.desc">{{desc.desc}}<span>{{desc.desc_red}}</span></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <sharePostBottom :options="[{title: 'Поделиться данной страницей:', data_title: 'BAZIS-A | Bazis Finance', data_link: 'https://sales.bazis.kz/bazis-finance', data_page: 'Bazis Finance', data_page_key: 'bazis-finance'}]"></sharePostBottom>
            <BanerBottomVertical :options="[{page: 'bazis-finance'}]" class="bazis-finance-vertical-baner-bottom" v-if="banerSystem != undefined && banerSystem.baner_system_active == 'true'"></BanerBottomVertical>
        </div>
    </div>
</template>

<script>
    // import BanerTopVertical from '@/components/baner-system/baner-top-vertical.vue'
    import BanerBottomVertical from '@/components/baner-system/baner-bottom-vertical.vue'
    import breadcrumbs from '@/components/breadcrumbs/breadcrumbs.vue'
    import sharePostBottom from '@/components/share/share-social-bottom.vue'
    import pageDescUniq from '@/components/page-static-desc-uniq/desc-uniq.vue'
    import {mapGetters} from 'vuex'
    import store from '@/store.js'
    export default {
        name: 'bazis-finance--page',
        components: {
            breadcrumbs,
            sharePostBottom,
            pageDescUniq,
            // BanerTopVertical,
            BanerBottomVertical,
        },
        data () {
            return {
                titlePage: 'Bazis Finance',
            }
        },
        computed: mapGetters({
            pageSetup: 'loadBazisFinancePage',
            currentCityArr: 'loadCurrentCityArr',
            titleSite: 'loadSiteTitle',
            banerSystem: 'loadBanerSystem',
        }),
        methods: {
        },
        beforeRouteEnter (to, from, next) {
            if (store.state.bazisFinance != null) {
                next(vm => {
                    vm.$parent.$refs.topProgress.done();
                    vm.$store.commit('removePageLoaderImg');
                });
            } else {
                store.dispatch('getBazisFinancePage').then((response) => {
                    // console.log(response, 'how to by')
                    if (response) {
                        next(vm => {
                            vm.$parent.$refs.topProgress.done();
                            vm.$store.commit('removePageLoaderImg');
                        });
                    } else {
                        next(false, vm => vm.$parent.$refs.topProgress.fail());
                    }
                });
            }
        },
        beforeCreate() {
            document.body.dataset.page = 'bazis-finance';
            // this.$store.dispatch('getHypothecPage');
        },
        created () {
            document.title = this.titlePage + ' - ' + this.titleSite;
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/purchase/bazis-finance.scss';
    // @import '@/styles/respond/purchase/hypothec-respond.scss';
</style>